import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { TrpcProvider } from "./TrpcProvider";
import { AppAuthProvider } from "./auth";
import "./index.css";
import { Router } from "./router";
import { useSync } from "./state/useSync";

/** Mounts the sync engine (bootstrap hydration + outbox flush) once, inside both providers. */
function SyncBoundary() {
  useSync();
  return <Router />;
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <AppAuthProvider>
      <TrpcProvider>
        <SyncBoundary />
      </TrpcProvider>
    </AppAuthProvider>
  </StrictMode>,
);
